<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>APP浮窗管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="id"
                        prop="id">
            <el-input placeholder="请输入ID"
                      v-model="search.id" clearable></el-input>
          </el-form-item>
          <el-form-item label="浮窗标题"
                        prop="title">
            <el-input placeholder="请输入浮窗标题"
                      v-model="search.title" clearable></el-input>
          </el-form-item>
          <el-form-item label="任务上线时间"
                        prop="launch_time">
            <el-date-picker
              v-model="search.launch_time"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="任务下线时间"
                        prop="end_time">
            <el-date-picker
              v-model="search.end_time"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="center"
              class="width-max"
              clearable>
            </el-date-picker>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <router-link :to="'/app-popup/create'">
          <el-button type="primary"
                     icon="sj-icon-add"
                     size="small">添加
          </el-button>
        </router-link>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="ID"
                         min-width="90"></el-table-column>
        <el-table-column prop="title"
                         label="浮窗标题"
                         min-width="190"></el-table-column>
        <el-table-column prop="launch_time"
                         label="上线时间"
                         min-width="120"></el-table-column>
        <el-table-column prop="end_time"
                         label="下线时间"
                         min-width="120"></el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         width="120"
                         :formatter="(row) => statusList[row.status]"
        ></el-table-column>
        <el-table-column prop="created_by_userid"
                         label="添加人"
                         min-width="120"
                         :formatter="(row) => row.created_by_username + '|' + row.created_by_userid"
        ></el-table-column>
        <el-table-column prop="created_at"
                         label="添加日期"
                         min-width="120"></el-table-column>
        <el-table-column prop="updated_at"
                         label="更新时间"
                         width="190"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="260">
          <template slot-scope="scope">
            <div class="button-gutter">
              <router-link :to="`/app-popup/detail/${scope.row.id}`">
                <el-button size="mini">详情</el-button>
              </router-link>
              <router-link v-if="Number(scope.row.status) !== 2" :to="`/app-popup/update/${scope.row.id}`">
                <el-button size="mini"
                           type="primary">编辑
                </el-button>
              </router-link>
              <el-button v-if="Number(scope.row.status) !== 2" type="success"
                         size="mini"
                         @click="onChangeStatus(scope.$index, table, '2')">启用
              </el-button>
              <el-button v-if="Number(scope.row.status) === 2"  type="danger"
                         size="mini"
                         @click="onChangeStatus(scope.$index, table, '3')">禁用
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../app-popup.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table-v3'

export default {
  mixins: [table, dateTimePicker],
  data () {
    return {
      searchRules,
      search: {
        id: null,
        title: null,
        launch_time: [],
        end_time: [],
      },
      statusList: {
        1: '待发布',
        2: '启用',
        3: '禁用',
      },
      exportHeader: [
        {
          key: 'name',
          text: 'APP浮窗管理名称',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({}),
  created () {},
  methods: {
    ...Vuex.mapActions([]),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getAppPopupTable', params)
    },
    onChangeStatus (index, rows, status) {
      let statusText = status === '2' ? '启用' : '禁用'
      const row = rows[index]
      this.$confirm(
        `确定要${statusText}【${row.title}】吗？${status === '2' ? '启用后该浮窗将对用户可见' : '禁用后该浮窗将对用户隐藏'}`,
        `${statusText}确认`,
        {
          type: 'warning',
          confirmButtonText: `确定${statusText}`,
          cancelButtonText: '取消'
        }
      ).then(() => {
        request.common('changeStatus', {id: row.id, status: status}).then(() => {
          this.$message.success(`${statusText}成功`)
          rows[index].status = status
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/app-popup/pages/AppPopupTable.vue